import { HttpClient } from './HttpClient';
import { Auth } from "./Auth";
import { Features } from "./Features";
import { Industries } from "./Industries";
import { LandplotsLayers } from "./LandplotsLayers";
import { LensLayers } from "./LensLayers";
import { Orders } from "./Orders";
import { Regions } from "./Regions";
import { ReportLayers } from "./ReportLayers";
import { Reports } from "./Reports";
import { Users } from "./Users";
import { UserSites } from "./UserSites";
import { Events } from "./Events";
export class Api {
    http;
    auth;
    features;
    industries;
    landplotsLayers;
    lensLayers;
    orders;
    regions;
    reportLayers;
    reports;
    users;
    userSites;
    events;
    constructor(url) {
        this.http = new HttpClient(url);
        this.auth = new Auth(this.http);
        this.features = new Features(this.http);
        this.industries = new Industries(this.http);
        this.landplotsLayers = new LandplotsLayers(this.http);
        this.lensLayers = new LensLayers(this.http);
        this.orders = new Orders(this.http);
        this.regions = new Regions(this.http);
        this.reportLayers = new ReportLayers(this.http);
        this.reports = new Reports(this.http);
        this.users = new Users(this.http);
        this.userSites = new UserSites(this.http);
        this.events = new Events(this.http);
    }
}
